import { render, staticRenderFns } from "./productSDSTable.vue?vue&type=template&id=32932681&"
import script from "./productSDSTable.vue?vue&type=script&lang=js&"
export * from "./productSDSTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports